import { useNavigate } from "flemo";
import { BookOpen, ClipboardList, Home } from "lucide-react";

import { nativeBridge } from "@/lib/native";
import { fadeTransition } from "@/lib/transitions";
import { cn } from "@/lib/utils";

import { Button } from "./ui/button";

export function BottomNav() {
  const { replace } = useNavigate();
  const pathname = window.location.pathname;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card px-8 z-50 shadow pb-safe">
      <div className="flex items-center justify-around max-w-3xl mx-auto h-14">
        <Button
          type="button"
          variant="ghost"
          size="icon-lg"
          aria-label="플래시카드"
          onClick={() => {
            nativeBridge.system.haptic("selection");
            replace("/flashcards", {}, { transitionName: fadeTransition.name });
          }}
          className={cn(
            "flex flex-col items-center p-5 transition-colors hover:text-primary",
            pathname === "/flashcards" || pathname.startsWith("/flashcards/")
              ? "text-primary"
              : "text-muted-foreground",
          )}
        >
          <BookOpen className="size-6" />
        </Button>

        <Button
          type="button"
          variant="ghost"
          size="icon-lg"
          aria-label="홈"
          onClick={() => {
            nativeBridge.system.haptic("selection");
            replace("/", {}, { transitionName: fadeTransition.name });
          }}
          className={cn(
            "flex flex-col items-center p-5 transition-colors hover:text-primary",
            pathname === "/" ? "text-primary" : "text-muted-foreground",
          )}
        >
          <Home className="size-6" />
        </Button>

        <Button
          type="button"
          variant="ghost"
          size="icon-lg"
          aria-label="테스트"
          onClick={() => {
            nativeBridge.system.haptic("selection");
            replace("/tests", {}, { transitionName: fadeTransition.name });
          }}
          className={cn(
            "flex flex-col items-center p-5 transition-colors hover:text-primary",
            pathname === "/tests" ? "text-primary" : "text-muted-foreground",
          )}
        >
          <ClipboardList className="size-6" />
        </Button>
      </div>
    </nav>
  );
}
